/**
 * 设备检测工具函数
 */

/**
 * 判断是否为移动设备
 * @returns {boolean} 是否为移动设备
 */
export const isMobile = (): boolean => {
  // 首先检查 window 对象是否存在（SSR 环境）
  if (typeof window === 'undefined') {
    return false;
  }

  // 检查 userAgent
  const userAgent = navigator.userAgent || navigator.vendor || (window as any).opera;

  // 移动设备的 userAgent 匹配模式
  // HarmonyOS/OpenHarmony/ArkWeb: 鸿蒙(含纯血鸿蒙)系统浏览器 UA 可能不含 Android
  // Mobi: 手机浏览器的通用标记(Chrome/Safari/华为浏览器均携带)
  // 注:用户主动开启"电脑版网站"伪装 UA 时,按桌面端展示,不做兜底识别
  const mobileRegex = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|HarmonyOS|OpenHarmony|ArkWeb|Mobi/i;

  return mobileRegex.test(userAgent);
};

/**
 * 判断是否为平板设备
 * @returns {boolean} 是否为平板设备
 */
export const isTablet = (): boolean => {
  if (typeof window === 'undefined') {
    return false;
  }

  const userAgent = navigator.userAgent || navigator.vendor || (window as any).opera;

  // 平板设备的 userAgent 匹配模式
  const tabletRegex = /iPad|Android(?!.*Mobile)/i;

  return tabletRegex.test(userAgent);
};

/**
 * 判断是否为桌面设备
 * @returns {boolean} 是否为桌面设备
 */
export const isDesktop = (): boolean => {
  return !isMobile() && !isTablet();
};

/**
 * 获取设备类型
 * @returns {'mobile' | 'tablet' | 'desktop'} 设备类型
 */
export const getDeviceType = (): 'mobile' | 'tablet' | 'desktop' => {
  if (isTablet()) {
    return 'tablet';
  }
  if (isMobile()) {
    return 'mobile';
  }
  return 'desktop';
};
